<template>
	
<com-section :section="section" :title="section.chance.title" :completed="completed" :active="active" v-on:next="$emit('next')" v-on:back="$emit('back')">

	<div class="text" v-html="section.chance.text"></div>

</com-section>

</template>

<script>

import comSection from './Section'

export default {

	props: ['section', 'active', 'completed'],

	components: {
		'com-section': comSection
	}
	
}

</script>

<style scoped>

</style>